// frontend/src/components/ai/TypingIndicator.tsx

export function TypingIndicator() {
  return (
    <div className="ai-mentor-typing" aria-live="polite" aria-label="MinikBot yazıyor">
      <div className="ai-mentor-avatar" aria-hidden="true">
        🤖
      </div>
      <div className="ai-mentor-typing-dots">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
